export default {
    leftNav(state){
        return state.leftNav
    },
    loading(state){
        return state.loading
    },
}
